import React from 'react';
import { FaPaintBrush, FaDesktop, FaCode, FaHashtag } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import useMediaQuery from '../hooks/useMediaQuery';

const services = [
  {
    id: 1,
    icon: <FaPaintBrush />,
    title: "Branding",
    description: "Cohesive visual identities that reflect your brand's personality and values — from logos and color palettes to full brand systems."
  },
  {
    id: 2,
    icon: <FaDesktop />,
    title: "Web Design",
    description: "Visually engaging, user-friendly interfaces that elevate your online presence and captivate users from the first click."
  },
  {
    id: 3,
    icon: <FaCode />,
    title: "Web Development",
    description: "Pixel-perfect, responsive websites built with clean code — turning designs into fast, functional web experiences."
  },
  {
    id: 4,
    icon: <FaHashtag />,
    title: "Social Media",
    description: "Scroll-stopping reels and posts tailored for every platform to grow your presence and engage your audience."
  },
];

const Expertise = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  return (
    <section id="services" className="py-24 max-w-screen-xl mx-auto px-6">
      <div className="text-center mb-16">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">What I Offer</span>
        <h2 className="text-4xl font-bold text-text">Services</h2>
      </div>

      <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {services.map(({ id, icon, title, description }) => (
          <motion.div
            key={id}
            className="group bg-accent rounded-2xl p-6 card-hover border border-border"
            {...(!isMobile ? {
              initial: { opacity: 0, y: 40 },
              animate: { opacity: inView ? 1 : 0, y: inView ? 0 : 40 },
              transition: { duration: 0.5, delay: id * 0.15, ease: [0.16, 1, 0.3, 1] }
            } : {})}
          >
            <div className="text-2xl mb-5 bg-primary/10 text-primary rounded-xl w-fit p-3 group-hover:bg-primary group-hover:text-white transition-all duration-300">
              {icon}
            </div>
            <h3 className="text-xl font-semibold text-text mb-3">{title}</h3>
            <p className="text-sm text-textlight leading-relaxed">{description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Expertise;
